// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2fy6T","buttons":"PendingPaymentAlert_buttons__3VDZS"};